import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Separator } from "../components/ui/separator";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { useState } from "react";
import { useBaseOwnerId, useModelCreate, useModelIndex } from "@rhino-project/core/hooks";
import { asHandoff, asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function FileDetail() {
    const organizationId = useBaseOwnerId();
    const { resources: handoffResources } = useModelIndex("handoff_event" as any, { limit: 25 } as any);
    const { resources: submissionResources } = useModelIndex("submission" as any, { limit: 1 } as any);
    const submission = asSubmission(listResults(submissionResources)[0] ?? {});
    const timeline = listResults(handoffResources).map(asHandoff);
    const { mutate: createHandoffEvent } = useModelCreate("handoff_event" as any);
    const { mutate: createCommunication } = useModelCreate("communication" as any);
    const addNote = () => {
      if (!submission.id) return;
      createHandoffEvent({ organization_id: Number.isFinite(organizationId) ? organizationId : undefined, submission_id: submission.id, from_party: "Navigator", to_party: "File", action: "Internal note", outcome: "Captured", notes: "Navigator note captured" } as any);
      createCommunication({ submission_id: submission.id, body: "Navigator note captured", communication_type: "note", status: "captured" } as any);
    };
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full grid gap-6 lg:grid-cols-2">
      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Company Journey</CardTitle>
      <CardDescription>Consolidated profile, submitted signals, translation snapshots, and current routing state.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
      <p><span className="font-medium">Company:</span> {submission.company}</p>
      <p><span className="font-medium">Submitted signals:</span> {timeline.length}</p>
      <p><span className="font-medium">Latest translation snapshot:</span> {submission.capability}</p>
      <p><span className="font-medium">Current route:</span> {submission.route}</p>
      <Separator />
      <Badge variant="secondary">Navigator-owned file</Badge>
      </CardContent>
      </Card>

      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Handoff History</CardTitle>
      <CardDescription>Track communications and outcomes across organizations.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Date</TableHead>
      <TableHead>From</TableHead>
      <TableHead>To</TableHead>
      <TableHead>Action</TableHead>
      <TableHead>Outcome</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {timeline.map((row) => (
      <TableRow key={row.date + row.action}>
      <TableCell>{row.date}</TableCell>
      <TableCell>{row.from}</TableCell>
      <TableCell>{row.to}</TableCell>
      <TableCell>{row.action}</TableCell>
      <TableCell>{row.outcome}</TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      <Button size="sm" variant="outline" onClick={addNote}>Add Note</Button>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}